var _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgress4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.103,
    cy: 66.603,
    r: 54.103,
    fill: "#010630"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.103,
    cy: 66.603,
    r: 54.103,
    fill: "#FF00B1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.2232,
    cy: 66.7232,
    r: 40.2232,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 48.66L66.265 46.5L62.0925 48.66L57.4475 49.365L55.3425 53.565L52 56.865L52.765 61.5L52 66.135L55.3425 69.435L57.4475 73.635L62.0925 74.34L66.265 76.5L70.4375 74.34L75.0825 73.635L77.1875 69.435L80.53 66.135L79.765 61.5L80.53 56.865L77.1875 53.565L75.0825 49.365L70.4375 48.66ZM73.4275 51.6425L75.1375 55.055L77.8525 57.735L77.2325 61.5L77.8525 65.265L75.1375 67.945L73.4275 71.3575L69.6525 71.93L66.265 73.685L62.8775 71.93L59.1025 71.3575L57.3925 67.945L54.6775 65.265L55.3 61.5L54.675 57.735L57.3925 55.055L59.1025 51.6425L62.8775 51.07L66.265 49.315L69.655 51.07L73.4275 51.6425Z",
    fill: "#010630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.265 75.9851V86.5001L66.265 84.0001L76.265 86.5001V75.9851L71.22 76.7501L66.265 79.3151L61.31 76.7501L56.265 75.9851Z",
    fill: "#010630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress4);
export default __webpack_public_path__ + "static/media/Progress 4.bd1f14d510a2e7aa6dcdc9bc903b8421.svg";
export { ForwardRef as ReactComponent };